import SecondaryButton from "../designSystem/buttons/SecondaryButton";
import Hero from "../designSystem/Hero";
import HeroBackground from "../../assets/images/home_header.jpg";
import SEO from "../designSystem/SEO";
import LightOutlinedButton from "../designSystem/buttons/LightOutlinedButton";
import LineLinkButton from "../designSystem/buttons/LineLinkButton";
import { ReactComponent as MortgageAdvice } from "../../assets/icons/mortgage_advice.svg";
import { ReactComponent as PensionAdvice } from "../../assets/icons/pension_advice.svg";
import { ReactComponent as InvestmentAdvice } from "../../assets/icons/investment_advice.svg";
import { ReactComponent as PersonalApproach } from "../../assets/icons/personal_approach.svg";
import HomeImage1 from "../../assets/images/home_image001.jpg";
import { Link, useNavigate } from "react-router-dom";
import { scrollToContact } from "../utils/navigation";

const services = [
  {
    title: "Pension Advice",
    path: "/pensions",
    icon: <PensionAdvice />,
    description:
      "Your pension is an important part of planning for your future. From understanding how pensions work to reviewing your investments and retirement options, we can help you make sense of your pension.",
  },
  {
    title: "Investment Advice",
    path: "/investments",
    icon: <InvestmentAdvice />,
    description:
      "Investing can play an important role in your wider financial plan. We can help you understand your investment options and how they could fit with your goals.",
  },
  {
    title: "Personal Approach",
    path: "/financial-advice",
    icon: <PersonalApproach />,
    description:
      "We take the time to understand your circumstances, explain your options clearly and help you make decisions that are right for you. Monk Financial Planning works with clients across North Wales and beyond.",
  },
  {
    title: "Mortgage Advice",
    path: "/mortgages",
    icon: <MortgageAdvice />,
    description:
      "From first-time buyers to remortgages and moving home, we can help you understand your mortgage options and the costs involved.",
  },
];

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div>
      <SEO
        title="Monk Financial Planning"
        description="Straightforward, personal advice on mortgages, pensions, investments and retirement planning from Monk Financial Planning."
        path="/"
      />
      <Hero
//         title={`Financial Clarity
// Direction & Confidence`}
//         subtitle="Wealth Management Solutions"
        showOverlay={true}
        backgroundImage={HeroBackground}
        titleAlign="left"
        subtitleAlign="left"
      >
        <div className="column py-xxl gap-xl">
          <div className="column  gap-m">
            <LineLinkButton onClick={scrollToContact} children="Contact Us" />
            <div className="column gap-s">
              <h1>
                FINANCIAL PLANNING,
                <br />
                MADE PERSONAL.
              </h1>
            </div>
            <div className="content">
              Whether you're planning for retirement, reviewing your pensions
              and investments, buying a home or simply looking for clarity
              around your finances, we provide straightforward, personalised
              advice to help you make informed decisions and plan confidently
              for the future.
            </div>
          </div>

          <div className="row-wrap gap-m">
            <SecondaryButton onClick={scrollToContact} text="MAKE AN ENQUIRY" />
            <LightOutlinedButton onClick={() => navigate("/about-us")} text="ABOUT US" />
          </div>
        </div>
      </Hero>

      <div className="background-container bg-primary-1 ">
        <div className="content-container services-menu row-wrap space-evenly gap-xl py-xl px-xxxl">
          {services.map((service) => (
            <Link
              key={service.path}
              to={service.path}
              className="row-wrap gap-m align-center"
              aria-label={`View ${service.title}`}
            >
              {service.icon}
              <div className="nav-text">{service.title}</div>
            </Link>
          ))}
        </div>
      </div>
      <div className="background-container bg-gray-3 ">
        <div className="content-container row align-stretch gap-xxxxl py-xxl px-xxxl row-ratio-47-63">
          <img src={HomeImage1} alt="Financial adviser meeting with a client" className="image-cover" />
          <div className="column gap-l">
            <LineLinkButton children="OUR SERVICES" />
            <h4 className="text-primary-1 uppercase">How Can We Help?</h4>
            {services.map((service) => (
              <div key={service.path} className="column gap-s">
                <Link
                  to={service.path}
                  className="content-semibold text-primary-1"
                >
                  {service.title}
                </Link>
                <div className="content text-primary-1">
                  {service.description}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="background-container bg-primary-1 ">
        <div className="content-container py-xxl px-xxxl column gap-l align-center">
          <LineLinkButton children="Matthew Monk | director" />
          <h4 className="h4-italic text-gray-3">
            Good financial advice starts with listening, so I take the time to
            truly understand where you are today, what matters most to you, and
            what you want to achieve. By doing so, I can provide clear, tailored
            guidance that gives you the confidence to make important financial
            decisions with certainty.
          </h4>
        </div>
      </div>
      <div className="background-container bg-gray-1 ">
        <div className="content-container py-xxl px-xxxl column gap-l align-center">
          <LineLinkButton onClick={scrollToContact} children="Contact Us" />
          <h4 className=" text-gray-3 uppercase">Ready to Talk?</h4>
          <div className="content text-gray-3">
            Whether you know exactly what you need or simply have a question,
            get in touch with Matthew to discuss your plans.
          </div>
          <SecondaryButton onClick={scrollToContact} text="MAKE AN ENQUIRY" />
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
